module.exports = __webpack_public_path__ + "static/media/education-object-3-2-0.61576588.png";